import { styled } from '@linaria/react';
import { colors, layout } from '../../theme/tokens';

export const Shell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${colors.white};
  --sticky-footer-offset-bottom: ${layout.mobileNavHeight};
  --shell-mobile-nav-height: ${layout.mobileNavHeight};

  @media (min-width: ${layout.desktopBreakpoint}) {
    --sticky-footer-offset-bottom: 0px;
    --shell-mobile-nav-height: 0px;
  }
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 0;
`;

export const ContentArea = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: ${layout.mobileNavHeight};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-bottom: 0;
  }
`;

export const Main = styled.main`
  flex: 1;
  min-width: 0;
  overflow-x: clip;
`;
